import { PaymentMethodType, CreditCard } from '@atlassian/cssxp-graphtypes';

export const mockBillingProfilesResult = {
  transactionAccount: {
    id: '5c509a3f-9687-4b21-a112-3b76af8873e3',
    billingProfiles: {
      totalCount: 10,
      __typename: 'InvoiceGroupConnection',
      nodes: [
        {
          id: 'b3b56e2e-dd15-4470-8234-9f0c0f128488',
          version: 1,
          name: 'IG-1',
          currency: 'USD',
          transactionAccountId: '5c509a3f-9687-4b21-a112-3b76af8873e3',
          defaultPaymentMethod: null,
          shipToParty: {
            id: 'af97f618-df00-45e7-8d37-8202388867ef',
            name: 'Adlassian Co',
            addressLine1: 'A205 MAP Enclave',
            addressLine2: null,
            city: 'Bangalore',
            state: 'KA',
            country: 'IN',
            postcode: '560075',
            taxId: 'test-tax-id',
          },
          isActive: true,
          __typename: 'InvoiceGroup',
        },
        {
          id: 'b3b56e2e-dd15-4470-8234-9f0c0f128489',
          version: 1,
          name: 'IG-2',
          currency: 'USD',
          transactionAccountId: '5c509a3f-9687-4b21-a112-3b76af8873e3',
          defaultPaymentMethod: {
            type: PaymentMethodType.CARD,
            paymentIssue: false,
            card: {
              expirationMonth: '12',
              expirationYear: '2023',
              last4Numbers: '1111',
              brand: 'visa',
            },
          } as CreditCard,
          shipToParty: {
            id: 'af97f618-df00-45e7-8d37-8202388867ef',
            name: 'Adlassian Co',
            addressLine1: 'A205 MAP Enclave',
            addressLine2: null,
            city: 'Bangalore',
            state: 'KA',
            country: 'IN',
            postcode: '560075',
            taxId: 'test-tax-id',
          },
          isActive: false,
          __typename: 'InvoiceGroup',
        },
      ],
      pageInfo: {
        hasNextPage: true,
        endCursor: 'asdfkjhasdf',
        __typename: 'PageInfo',
      },
    },
  },
  __typename: 'TransactionAccount',
};

export const mockBillingProfilesResultWithCorrectCount = {
  ...mockBillingProfilesResult,
  transactionAccount: {
    ...mockBillingProfilesResult.transactionAccount,
    billingProfiles: {
      ...mockBillingProfilesResult.transactionAccount.billingProfiles,
      totalCount: 2,
    },
  },
};

export const mockBillingProfilesPaginatedResult = {
  ...mockBillingProfilesResult,
  transactionAccount: {
    ...mockBillingProfilesResult.transactionAccount,
    billingProfiles: {
      ...mockBillingProfilesResult.transactionAccount.billingProfiles,
      nodes: Array(8).fill(mockBillingProfilesResult.transactionAccount.billingProfiles.nodes[0]),
      totalCount: 12,
    },
  },
};

export const mockBillingProfilesWithDeferredPaymentData = {
  transactionAccount: {
    id: '5c509a3f-9687-4b21-a112-3b76af8873e3',
    billingProfiles: {
      totalCount: 10,
      __typename: 'InvoiceGroupConnection',
      nodes: [
        {
          id: 'b3b56e2e-dd15-4470-8234-9f0c0f128488',
          version: 1,
          name: 'IG-1',
          currency: 'USD',
          transactionAccountId: '5c509a3f-9687-4b21-a112-3b76af8873e3',
          defaultPaymentMethod: null,
          shipToParty: {
            id: 'af97f618-df00-45e7-8d37-8202388867ef',
            name: 'Adlassian Co',
            addressLine1: 'A205 MAP Enclave',
            addressLine2: null,
            city: 'Bangalore',
            state: 'KA',
            country: 'IN',
            postcode: '560075',
            taxId: 'test-tax-id',
          },
          __typename: 'InvoiceGroup',
        },
        {
          id: 'b3b56e2e-dd15-4470-8234-9f0c0f128489',
          version: 1,
          name: 'IG-2',
          currency: 'USD',
          transactionAccountId: '5c509a3f-9687-4b21-a112-3b76af8873e3',
          defaultPaymentMethod: {
            id: 'f579f70e-0665-4ea3-b829-3f4955d1f74f',
            type: 'DEFERRED',
            default: true,
            paymentIssue: false,
            totalCreditLimit: 300000,
            paymentMethod: 'NET14',
            terms: {
              invoiceDueDays: 14,
              payOnStatement: true,
              __typename: 'PaymentOnTermsDetails',
            },
          },
          shipToParty: {
            id: 'af97f618-df00-45e7-8d37-8202388867ef',
            name: 'Adlassian Co',
            addressLine1: 'A205 MAP Enclave',
            addressLine2: null,
            city: 'Bangalore',
            state: 'KA',
            country: 'IN',
            postcode: '560075',
            taxId: 'test-tax-id',
          },
          __typename: 'InvoiceGroup',
        },
      ],
      pageInfo: {
        hasNextPage: true,
        endCursor: 'asdfkjhasdf',
        __typename: 'PageInfo',
      },
    },
  },
  __typename: 'TransactionAccount',
};

export const mockBillingProfilesWithPaypalPaymentData = {
  transactionAccount: {
    id: '5c509a3f-9687-4b21-a112-3b76af8873e3',
    billingProfiles: {
      totalCount: 10,
      __typename: 'InvoiceGroupConnection',
      nodes: [
        {
          id: 'b3b56e2e-dd15-4470-8234-9f0c0f128488',
          version: 1,
          name: 'IG-1',
          currency: 'USD',
          transactionAccountId: '5c509a3f-9687-4b21-a112-3b76af8873e3',
          defaultPaymentMethod: null,
          shipToParty: {
            id: 'af97f618-df00-45e7-8d37-8202388867ef',
            name: 'Adlassian Co',
            addressLine1: 'A205 MAP Enclave',
            addressLine2: null,
            city: 'Bangalore',
            state: 'KA',
            country: 'IN',
            postcode: '560075',
            taxId: 'test-tax-id',
          },
          __typename: 'InvoiceGroup',
        },
        {
          id: 'b3b56e2e-dd15-4470-8234-9f0c0f128489',
          version: 1,
          name: 'IG-2',
          currency: 'USD',
          transactionAccountId: '5c509a3f-9687-4b21-a112-3b76af8873e3',
          defaultPaymentMethod: {
            id: 'f579f70e-0665-4ea3-b829-3f4955d1f74f',
            type: 'PAYPAL',
            default: true,
            paymentIssue: false,
            payPal: {
              name: 'Paypal-partner',
              email: 'buyer-us@atlassian.com',
            },
          },
          shipToParty: {
            id: 'af97f618-df00-45e7-8d37-8202388867ef',
            name: 'Adlassian Co',
            addressLine1: 'A205 MAP Enclave',
            addressLine2: null,
            city: 'Bangalore',
            state: 'KA',
            country: 'IN',
            postcode: '560075',
            taxId: 'test-tax-id',
          },
          __typename: 'InvoiceGroup',
        },
      ],
      pageInfo: {
        hasNextPage: true,
        endCursor: 'asdfkjhasdf',
        __typename: 'PageInfo',
      },
    },
  },
  __typename: 'TransactionAccount',
};
